import { ofType } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { PayloadAction } from '../../../store.model';
import { EvaluationService, MainConfig } from '../../core';
import { getModuleInjector } from '../../evaluation.metadata';
import { ActionType } from '../landing.action';
import { ReloadSearchRet } from '../model/reload-search-ret.model';

import { Reload, reloadResult } from './reload.action';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const reload = (action: Observable<PayloadAction<ActionType, Reload>>) =>
    action.pipe(
        ofType(ActionType.EVAL_LANDING__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const service =
                getModuleInjector().get<EvaluationService>(EvaluationService);
            const obses: [
                Observable<MainConfig> | Observable<ReloadSearchRet>,
            ] = [service.retrieveConfig('main')];
            obses.push(
                ...act.payload.searchOpts.map((e) => {
                    return service
                        .search(e.params)
                        .pipe(map((ret) => ({ type: e.type, result: ret })));
                }),
            );
            return forkJoin(obses).pipe(
                map((ret) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                            config: ret[0] as MainConfig,
                            searchRets: ret.splice(1) as ReloadSearchRet[],
                        },
                        act.storePath,
                    );
                }),
                catchErrorLogRet(
                    of(reloadResult({ ...act.payload }, act.storePath)),
                ),
            );
        }),
    );
